import React, { Component, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from '../layout/';

import Homepage from '../pages/FrontendHomepage';

import News from '../pages/FrontendNews';

import Login from '../pages/Login';
import LoginBackOffice from '../pages/LoginBackOffice';
import PreparePage from '../pages/PreparePage';

import Register from '../pages/Register';
import Logout from '../pages/Logout';

import NotFound from '../pages/NotFound';
import Dashboard from '../pages/Dashboard';

import { routes } from './RouteLists';
import { frontendRoutes } from './PublicRouteLists';
import ResetPassword from '../pages/ResetPassword';

class AppRoutes extends Component {
    render = () => {
        return (
            <Suspense fallback={
                <div className="preloader-it">
                    <div className="loader-pendulums"></div>
                </div>
            }>
                <Routes>
                    {/* Public routes */}
                    <Route path="/" element={<Homepage />} />
                    <Route path="/news" element={<News />} />

                    <Route path="/external-users" element={<Login />} />
                    <Route path="/back-office" element={<LoginBackOffice />} />
                    <Route path="/reset-password" element={<ResetPassword />} />
                    <Route path="/prepare" element={<PreparePage />} />

                    <Route path="/register" element={<Register />} />                    
                    <Route path="/logout" element={<Logout />} />

                    {/* Frontend without Layout */}
                    <Route
                        path="/*"
                        element={
                            <Routes>
                                {frontendRoutes.map((obj, i) => (
                                <Route
                                    key={i}
                                    path={obj.path.replace('/apps/', '')}
                                    element={obj.element}
                                />
                                ))}

                                {/* จับ route ที่ไม่ match ภายใน /apps */}
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        }
                    />

                    {/* Routes with Layout */}
                    <Route
                        path="/apps/*"
                        element={
                            <Layout>
                            <Routes>
                                {routes.map((obj, i) => (
                                <Route
                                    key={i}
                                    path={obj.path.replace('/apps/', '')}
                                    element={obj.element}
                                />
                                ))}

                                {/* จับ route ที่ไม่ match ภายใน /apps */}
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                            </Layout>
                        }
                    />

                    {/* Path not found - show 404 page without layout */}
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Suspense>
        );
    }
}

export default AppRoutes;
